const modalsShow = () => {
  if (document.querySelector("#inscription-compte")) {
    $('#inscription-compte').modal('show');
  }
}

export { modalsShow };
